import React, {useContext} from "react";
import {Col, FormFeedback, FormGroup, Input, Label} from "reactstrap";
import LangContext from "../../../providers/LangContext";

const SelectList = ({id, name, description, placeholder, value, options, onChange, errors, required}) => {
    const {lang} = useContext(LangContext);
    return (
        <FormGroup row className="mb-2">
            <Label md={4} className="pr-md-1">{description} {!!required && '*'}</Label>
            <Col md={8}>
                <Input
                    type="select"
                    invalid={!!errors}
                    name={description}
                    value={value ?? ""}
                    onChange={e => {
                        onChange(id, {
                            [name]: (e.target.value === "0" ? null : e.target.value)
                        });
                    }}
                >
                    <option value="0">{placeholder ?? lang.get('sites.form_make_selection')}</option>
                    {options.map(option => {
                        return (
                            <option
                                value={option.id}
                                key={`custom-option=${option.id}`}
                            >
                                {option.name}
                            </option>
                        );
                    })}
                </Input>
                {!!errors ? <FormFeedback className="d-block">{errors[0]}</FormFeedback> : ''}
            </Col>
        </FormGroup>
    );
};

export default SelectList;
